// section-categories.js
document.addEventListener("DOMContentLoaded", function () {

  // 1. SLIDER FUNCTIONALITY
  // Moved to the top so it initializes on ALL pages, regardless of anchor links
  const sliders = document.querySelectorAll('.categories-container-wrapper');

  sliders.forEach(wrapper => {
    const sliderEl = wrapper.querySelector('.native-slider');
    if (!sliderEl) return;

    class NativeSlider {
      constructor(wrapper, slider) {
        this.wrapper = wrapper;
        this.slider = slider;
        this.prevBtns = wrapper.querySelectorAll('.prev-btn');
        this.nextBtns = wrapper.querySelectorAll('.next-btn');

        this.isDown = false;
        this.startX;
        this.scrollLeft;

        this.init();
      }

      init() {
        this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.scroll('prev')));
        this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.scroll('next')));

        this.slider.addEventListener('scroll', () => {
          window.requestAnimationFrame(() => this.updateButtonStates());
        });

        this.slider.addEventListener('mousedown', (e) => this.startDrag(e));
        this.slider.addEventListener('mouseleave', () => this.stopDrag());
        this.slider.addEventListener('mouseup', () => this.stopDrag());
        this.slider.addEventListener('mousemove', (e) => this.moveDrag(e));

        const images = this.slider.querySelectorAll('img');
        images.forEach(img => {
          img.addEventListener('dragstart', (e) => e.preventDefault());
        });

        this.updateButtonStates();
        window.addEventListener('resize', () => this.updateButtonStates());

        // Fix: Recalculate after images/fonts fully load so widths are perfectly accurate
        window.addEventListener('load', () => this.updateButtonStates());
      }

      /*
       * Scroll geometry is physical and CSS logical properties cannot fix it.
       * In an RTL scroll container the spec-compliant `scrollLeft` starts at 0
       * on the right edge and grows NEGATIVE toward the end. Unhandled, the
       * row reports itself as "already at the end" from the moment it renders,
       * and because .nav-btn:disabled sets opacity:0 that shows up as an empty
       * circle where an arrow should be, with the pills clipped.
       *
       * Direction comes from computed style rather than the locale, so this
       * follows whatever <html dir> inherits down and needs no locale list.
       *
       * NOTE: moveDrag() below needs no change — it offsets from the scroll
       * position captured on mousedown, so the sign convention cancels out and
       * "content follows the finger" already holds in both directions.
       */
      isRTL() {
        return window.getComputedStyle(this.slider).direction === 'rtl';
      }

      /* Distance travelled from the start edge, direction-agnostic. */
      scrolled() {
        return Math.abs(this.slider.scrollLeft);
      }

      scroll(direction) {
        const pill = this.slider.querySelector('.category-pill');
        const pillWidth = pill ? pill.offsetWidth : 150;
        const style = window.getComputedStyle(this.slider);
        const gap = parseFloat(style.gap) || 12;
        const scrollAmount = (pillWidth + gap) * 2;

        // scrollBy takes a PHYSICAL delta, so "next" is leftward in RTL.
        const forward = this.isRTL() ? -scrollAmount : scrollAmount;
        const leftAmount = direction === 'next' ? forward : -forward;

        this.slider.scrollBy({
          left: leftAmount,
          behavior: 'smooth'
        });
      }

      updateButtonStates() {
        const tolerance = 5;
        const { scrollWidth, clientWidth } = this.slider;
        const scrollLeft = this.scrolled();
        const isStart = scrollLeft <= tolerance;
        const maxScroll = scrollWidth - clientWidth;
        const isEnd = scrollLeft >= maxScroll - tolerance;

        // Fix: Added Math.ceil and +10 to prevent sub-pixel rounding bugs from forcing arrows to show
        const hasScroll = Math.ceil(scrollWidth) > (clientWidth + 10);

        this.prevBtns.forEach(btn => {
          btn.disabled = isStart;
          btn.style.display = (hasScroll && window.innerWidth >= 750) ? 'flex' : 'none';
        });
        this.nextBtns.forEach(btn => {
          btn.disabled = isEnd;
          btn.style.display = (hasScroll && window.innerWidth >= 750) ? 'flex' : 'none';
        });
      }

      startDrag(e) {
        if (window.innerWidth < 750) return;
        this.isDown = true;
        this.slider.classList.add('active');
        this.startX = e.pageX - this.slider.offsetLeft;
        this.scrollLeft = this.slider.scrollLeft;
        this.slider.style.scrollSnapType = 'none';
        this.slider.style.scrollBehavior = 'auto';
      }

      stopDrag() {
        if (!this.isDown) return;
        this.isDown = false;
        this.slider.classList.remove('active');
        this.slider.style.scrollSnapType = 'x mandatory';
        this.slider.style.scrollBehavior = 'smooth';
      }

      moveDrag(e) {
        if (!this.isDown) return;
        e.preventDefault();
        const x = e.pageX - this.slider.offsetLeft;
        const walk = (x - this.startX) * 1.5;
        this.slider.scrollLeft = this.scrollLeft - walk;
      }
    }

    new NativeSlider(wrapper, sliderEl);
  });


  // 2. SCROLL SPY LOGIC
  const container = document.querySelector(".categories-container");
  if (!container) return;

  const pills = container.querySelectorAll('.category-pill[href^="#"]');

  // Fix: This return statement now ONLY safely kills the scroll spy, not the slider above it!
  if (pills.length === 0) return;

  const sections = [];

  // Identify target sections
  pills.forEach(pill => {
    const id = pill.getAttribute('href');
    if (id && id.length > 1) {
      const section = document.querySelector(id);
      if (section) {
        sections.push(section);
        section.style.scrollMarginTop = "180px";
      }
    }
  });

  // Click Handling 
  container.addEventListener('click', function (e) {
    const pill = e.target.closest('.category-pill[href^="#"]');
    if (!pill) return;

    e.preventDefault();
    const targetId = pill.getAttribute('href');
    const targetSection = document.querySelector(targetId);

    if (targetSection) {
      const headerOffset = 140;
      const elementPosition = targetSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + (window.pageYOffset || document.documentElement.scrollTop) - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      pills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    }
  });

  // Fixed Intersection Observer Logic
  const observerOptions = {
    root: null,
    rootMargin: "-20% 0px -50% 0px",
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    if (window.innerWidth < 750) return;
    const visibleSections = sections.filter(section => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const topBound = viewportHeight * 0.2;
      const bottomBound = viewportHeight * 0.5;
      return rect.top < bottomBound && rect.bottom > topBound;
    });

    if (visibleSections.length > 0) {
      const activeSection = visibleSections[visibleSections.length - 1];
      const activeId = '#' + activeSection.id;

      const activePill = container.querySelector(`.category-pill[href="${activeId}"]`);
      if (activePill) {
        pills.forEach(pill => pill.classList.remove('active'));
        activePill.classList.add('active');

        const hasScrollbar = container.scrollWidth > (container.clientWidth + 10);
        if (hasScrollbar) {
          // --- THE SAFE SCROLL FIX ---
          // Instead of scrollIntoView (which causes page jiggling), we manually calculate 
          // the center position and ONLY move the container's internal scroll bar.
          const scrollPos = activePill.offsetLeft - (container.clientWidth / 2) + (activePill.clientWidth / 2);

          /* scrollPos is a PHYSICAL x coordinate, because offsetLeft always
           * measures rightward from the offset parent regardless of `dir`.
           * scrollLeft does not share that convention: in an RTL container it
           * is 0 at the right-hand start edge and runs NEGATIVE toward the
           * end, so a positive target clamps to 0 and the strip jumps back to
           * its first pill every time the observer fires.
           *
           * Converting is one subtraction: at scrollLeft = s the viewport's
           * physical left edge sits at (maxScroll + s) in RTL and at s in LTR,
           * so the value that puts that edge on scrollPos is
           * scrollPos - maxScroll. The LTR branch is the original expression,
           * untouched. Same direction test as NativeSlider.isRTL() above.
           */
          const isRTL = window.getComputedStyle(container).direction === 'rtl';
          const maxScroll = container.scrollWidth - container.clientWidth;

          container.scrollTo({
            left: isRTL ? scrollPos - maxScroll : scrollPos,
            behavior: 'smooth'
          });
        }
      }
    } else {
      pills.forEach(pill => pill.classList.remove('active'));
    }
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });

});